import React from 'react';
import { useDispatch } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { useMarkDelete } from '@/src/components/project/Library/api/markDelete';
import { LibraryItemIdsVersionedDTO } from '@/src/components/project/Library/types';
import { showToast } from '@/src/globalFunction';

type RestoreProps = {
  itemIdsVersioned: LibraryItemIdsVersionedDTO;
  multiple?: boolean;
};

export const Restore = ({ itemIdsVersioned }: RestoreProps) => {
  const markDeleteMutation = useMarkDelete();
  const dispatch = useDispatch();

  const handleRestore = async () => {
    const response = await markDeleteMutation.mutateAsync({
      itemIdsVersioned,
      inTrash: false,
    });

    if (response['error-results'].length > 0) {
      showToast('error', 'Something went wrong. Please try again later.');
      return;
    }

    if (response['conflict-results'].length > 0) {
      showToast('error', 'The document has already been upated. Please refresh and try again.');
      return;
    }

    const restoredFiles = response['success-results'];
    const typeLabel = restoredFiles.some((f) => f.source === 'document' || f.type === 'document')
      ? 'file/s '
      : 'folder/s ';

    showToast('success', `${restoredFiles.length} ${typeLabel} has been restored`);

    dispatch({ type: 'RESET_SELECTED_ITEMS' });
  };
  return (
    <a
      onClick={handleRestore}
      data-tooltip-id={`actionItem_${itemIdsVersioned.toString()}_singleMove`}
    >
      <i className="material-icons">restore</i>
      <Tooltip
        id={`actionItem_${itemIdsVersioned.toString()}_singleMove`}
        place="bottom"
        effect="solid"
      >
        Restore
      </Tooltip>
    </a>
  );
};
